// extracted by mini-css-extract-plugin
var _1 = "ScrollBanvas__main--nAUIX";
export { _1 as "main" }
